import Axios from 'axios';
import { makeUrl } from '../../../utils/makeUrl';

function handlerChange() {
    window.location = this.value;
}
export const renderChips = async params => {
    const { skuId, dom, contextPath } = params;
    try {
        const response = await Axios.get(
            makeUrl(
                `${contextPath}/cartridges/ProductDetailPage/includes/MultipleSkus.jsp?skuId=${skuId}`
            )
        );
        if (response.data.trim()) {
            dom.innerHTML = response.data;
            const chipsLinks = Array.from(document.querySelectorAll('.chips-links__select'));
            chipsLinks.forEach(item => item.addEventListener('change', handlerChange));
        } else {
            dom.parentElement.removeChild(dom);
        }
    } catch (e) {
        throw e;
    }
};
